import React from 'react'

const Advisor7 = () => {
  return (
<section className="w-full">
  {/* Full Background Image Section */}
  <div
    className="w-full h-[850px] bg-cover "
    style={{
      backgroundImage:
        "url('https://res.cloudinary.com/dzngpgki4/image/upload/v1745440160/image_27_wsy1bb.png')",
    }}
  ></div>

  {/* Box below the image */}
  <div
    className="w-full h-[223px] bg-[#152C24] rounded-b-[5px] md:px-20 md:pt-5 md:pb-5" 
  >
    <h1 className='text-white font-medium md:text-[48px]'>
    DR MARY MWALE
    </h1>
    <h1 className='text-white font-extrabold md:text-[64px] md:mt-1'>
    Advisor - Food security
    </h1>
  </div>

  {/* Paragraph Section */}
  <div className="w-full bg-[#2E453D] px-6 md:px-20 py-16">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">

  <p className="md:mb-10 mb-5">
  Dr. Mary Mabel Mwale is a highly accomplished Food Security and Nutrition Policy Specialist with over 30 years of experience in policy formulation, analysis, and advocacy. She has extensive expertise in food security monitoring, early warning systems, crisis management and disaster risk reduction, representing Kenya at national and international levels. A seasoned consultant for organizations like FAO and GIZ, she has contributed to key policies such as the National Food and Nutrition Security Policy and regional strategies. Dr. Mwale holds a Doctorate in Nutrition and multiple certifications, with a strong research background evidenced by her scientific publications. Her skills include leadership, analytical thinking, and effective communication.
  </p>

 

</div>

  <div className='md:mt-40 mt-10'></div>
</div>

  </div>
</section>

  )
}

export default Advisor7